import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type EvaluateProvingQueryVariables = {
  person: Types.Scalars['String']
};


export type EvaluateProvingQuery = (
  { __typename?: 'Query' }
  & { evaluateProving: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, 'id'>
  )> }
);

export type EvaluateWikiQueryVariables = {
  person: Types.Scalars['String']
};


export type EvaluateWikiQuery = (
  { __typename?: 'Query' }
  & { evaluateWiki: Array<(
    { __typename?: 'Wiki' }
    & Pick<Types.Wiki, 'topic'>
  )> }
);

export const EvaluateProvingDocument = gql`
    query EvaluateProving($person: String!) {
  evaluateProving(person: $person) {
    id
  }
}
    `;

    export function useEvaluateProvingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EvaluateProvingQuery, EvaluateProvingQueryVariables>) {
      return ApolloReactHooks.useQuery<EvaluateProvingQuery, EvaluateProvingQueryVariables>(EvaluateProvingDocument, baseOptions);
    };
      export function useEvaluateProvingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EvaluateProvingQuery, EvaluateProvingQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EvaluateProvingQuery, EvaluateProvingQueryVariables>(EvaluateProvingDocument, baseOptions);
      };
      
export type EvaluateProvingQueryHookResult = ReturnType<typeof useEvaluateProvingQuery>;
export type EvaluateProvingQueryResult = ApolloReactCommon.QueryResult<EvaluateProvingQuery, EvaluateProvingQueryVariables>;
export const EvaluateWikiDocument = gql`
    query EvaluateWiki($person: String!) {
  evaluateWiki(person: $person) {
    topic
  }
}
    `;

    export function useEvaluateWikiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EvaluateWikiQuery, EvaluateWikiQueryVariables>) {
      return ApolloReactHooks.useQuery<EvaluateWikiQuery, EvaluateWikiQueryVariables>(EvaluateWikiDocument, baseOptions);
    };
      export function useEvaluateWikiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EvaluateWikiQuery, EvaluateWikiQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EvaluateWikiQuery, EvaluateWikiQueryVariables>(EvaluateWikiDocument, baseOptions);
      };
      
export type EvaluateWikiQueryHookResult = ReturnType<typeof useEvaluateWikiQuery>;
export type EvaluateWikiQueryResult = ApolloReactCommon.QueryResult<EvaluateWikiQuery, EvaluateWikiQueryVariables>;